import Rails from '@rails/ujs'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  submit (e) {
    Rails.fire(e.target.closest('form'), 'submit')
  }
}
